"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessResponseToJSON = exports.BusinessResponseFromJSONTyped = exports.BusinessResponseFromJSON = exports.instanceOfBusinessResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessStatus_1 = require("./BusinessStatus");
var BusinessType_1 = require("./BusinessType");
/**
 * Check if a given object implements the BusinessResponse interface.
 */
function instanceOfBusinessResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBusinessResponse = instanceOfBusinessResponse;
function BusinessResponseFromJSON(json) {
    return BusinessResponseFromJSONTyped(json, false);
}
exports.BusinessResponseFromJSON = BusinessResponseFromJSON;
function BusinessResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, BusinessStatus_1.BusinessStatusFromJSON)(json['status']),
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, BusinessType_1.BusinessTypeFromJSON)(json['type']),
    };
}
exports.BusinessResponseFromJSONTyped = BusinessResponseFromJSONTyped;
function BusinessResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'status': (0, BusinessStatus_1.BusinessStatusToJSON)(value.status),
        'type': (0, BusinessType_1.BusinessTypeToJSON)(value.type),
    };
}
exports.BusinessResponseToJSON = BusinessResponseToJSON;
